import { render } from "./AppLoader.vue?vue&type=template&id=689ba514&ts=true"
import script from "./AppLoader.vue?vue&type=script&lang=ts"
export * from "./AppLoader.vue?vue&type=script&lang=ts"

import "./AppLoader.vue?vue&type=style&index=0&id=689ba514&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__